module.exports = __webpack_public_path__ + "static/product-pc-content-2-1480cad7a1451c27cea6925f902735b7.jpg";